"use client";
import { jsx } from "react/jsx-runtime";
import { Button } from "@nxt-costco-com/forge-components";
const COMPONENT_NAME = "ProductActions";
const SignInButton = ({
  productTitleId,
  pdpNavigationUrl,
  onClick,
  buttonStyles,
  productInfoData,
  signinbuttonlabel
}) => {
  return /* @__PURE__ */ jsx(
    Button,
    {
      "aria-describedby": productTitleId,
      onClick: () => onClick(pdpNavigationUrl || ""),
      sx: buttonStyles,
      uniqueId: `${COMPONENT_NAME}_${productInfoData.partNumber}`,
      variant: "primary",
      children: signinbuttonlabel
    }
  );
};
export {
  SignInButton
};
